import React from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import AffiliateOverview from "../../components/admin/affiliates/AffiliateOverview";
import CommissionLedger from "../../components/admin/affiliates/CommissionLedger";
import AffiliateProgramSettings from "../../components/admin/affiliates/AffiliateProgramSettings";
import MilestonesAdmin from "../../components/admin/affiliates/MilestonesAdmin";
import WithdrawalsAdmin from "../../components/admin/affiliates/WithdrawalsAdmin";

const TABS = [
    ["overview", "Overview"],
    ["rewards", "Rewards ledger"],
    ["withdrawals", "Withdrawals"],
    ["milestones", "Milestones & gifts"],
    ["settings", "Program settings"],
];

// Referral (affiliate) program: dashboard and affiliates, the reward ledger, and the program rules.
const AffiliatesView = () => {
    const [params, setParams] = useSearchParams();
    const tab = TABS.some(([key]) => key === params.get("tab")) ? params.get("tab") : "overview";

    return (
        <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
                Referral Program
            </Typography>
            <Tabs
                value={tab}
                onChange={(_, value) => setParams(value === "overview" ? {} : { tab: value })}
                sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
            >
                {TABS.map(([key, label]) => (
                    <Tab key={key} value={key} label={label} />
                ))}
            </Tabs>
            {tab === "overview" ? <AffiliateOverview /> : null}
            {tab === "rewards" ? <CommissionLedger /> : null}
            {tab === "withdrawals" ? <WithdrawalsAdmin /> : null}
            {tab === "milestones" ? <MilestonesAdmin /> : null}
            {tab === "settings" ? <AffiliateProgramSettings /> : null}
        </Box>
    );
};

export default AffiliatesView;
